// src/features/explore/panels/ExploreMediaPanel.tsx
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Panel, SectionLabel } from '@/ui';
import { PanelEmpty } from '@/components/panels/PanelEmpty';
import { ExploreCoverThumb } from '../ExploreCoverThumb';
import type { ExploreItem } from '@/core/models/explore';

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 6px;
`;
// aspect-ratio gives the Tile a definite height in modern engines, but a percentage-height
// child ("height: 100%" on ExploreCoverThumb's layers) still collapses to 0 wherever
// aspect-ratio isn't computed before layout (older engines, some test DOMs). position:
// relative + an absolutely-positioned cover layer sidesteps that dependency entirely.
const Tile = styled(Link)`
  position: relative;
  aspect-ratio: 1 / 1;
  border-radius: ${({ theme }) => theme.radius.sm};
  overflow: hidden;
  display: block;
`;

const TileCover = styled.div`
  position: absolute;
  inset: 0;
`;

export interface ExploreMediaPanelProps {
  feed: ExploreItem[];
}

export function ExploreMediaPanel({ feed }: ExploreMediaPanelProps) {
  const tiles = feed.slice(0, 9);
  return (
    <Panel>
      <SectionLabel as="h2">Explore Media</SectionLabel>
      {tiles.length === 0 ? (
        <PanelEmpty>No media yet.</PanelEmpty>
      ) : (
        <Grid>
          {tiles.map((i) => (
            <Tile key={i.id} to={`/post/${i.postId}`} aria-label={i.title}>
              <TileCover>
                <ExploreCoverThumb postId={i.postId} cover={i.cover} />
              </TileCover>
            </Tile>
          ))}
        </Grid>
      )}
    </Panel>
  );
}
